import translate from 'angular-translate';

export default angular.module('eventix.common.services.uimessages',[translate])
/**
 * @ngdoc service
 * @name eventix.common.services.UIMessages
 * @description
 * Handle user feedback messages application wide
 *
 * Allows messages to persist between states and provides a common API,
 * leveraging the common Array. Messages are automatically cleared after
 * a default of 5 seconds.
 *
 */
/**
 * @ngdoc service
 * @name eventix.common.services.UIMessagesProvider
 * @description
 * Handle user feedback messages application wide
 *
 * Allows messages to persist between states and provides a common API,
 * leveraging the common Array. Messages are automatically cleared after
 * a default of 5 seconds.
 *
 */
    .provider('UIMessages', function() {
        var defaultTimeout = 5000;
        /**
     * @ngdoc method
     * @name eventix.common.services.UIMessagesProvider#setTimeout
     * @methodOf eventix.common.services.UIMessagesProvider
     * @description
     * Set the default timeout for messages
     *
     * @param {Number} time The amount of milliseconds after which a message should disappear
     */
        this.setTimeout = (time) => {
            defaultTimeout = parseInt(time, 10);
        };
        this.$get = /*@ngInject*/function($translate, $timeout, $window) {
            var UIMessages = [];

            /**
         * @ngdoc method
         * @name eventix.common.services.UIMessages#clear
         * @methodOf eventix.common.services.UIMessages
         * @description
         * Clear one or all messages from the stack
         *
         * @param {Object} element Element from the stack, optional
         * @example
         * <pre>
         * UIMessages.clear();
         * UIMessages.clear(UIMessages[2]);
         * </pre>
         */
            Object.defineProperty(UIMessages, 'clear', {
                enumerable: false,
                value: function(el) {
                    var l,i;
                    if(el !== undefined) {
                        i = typeof el === 'number' ? el : _.findIndex(this, el);
                        if(i > -1)
                            Array.prototype.splice.call(this,i,1);
                        return;
                    }
                    Array.prototype.splice.call(this,0, this.length);
                }
            });

            /**
         * @ngdoc method
         * @name eventix.common.services.UIMessages#push
         * @methodOf eventix.common.services.UIMessages
         * @description
         * Add a message to the queue
         *
         * @param {Object|String} element Message to display to user
         * @example
         * <pre>
         * UIMessages.push('Some alert');
         * UIMessages.push('translations.something.else');
         * UIMessages.push({
         *     message: 'translations.something.else',
         *     translateValues: { count: 2 },
         *     timeout: 5000, // Timeout in ms, defaults to 5 seconds, 0 to disable
         *     type: 'info' // Class of message for visual styling
         * });
         * </pre>
         */
            Object.defineProperty(UIMessages, 'push',{
                value: function(element) {
                    if(typeof element === 'string')
                        element = { message: element };
                    if(/^([a-z1-9_]\.?)*$/i.test(element.message))
                        element.message = $translate.instant(element.message, element.translateValues);
                    if($window.parentIFrame && $window.parentIFrame.sendMessage) {
                        $window.parentIFrame.sendMessage(element.message);
                        return;
                    }
                    if(_.find(this, element))
                        return;
                    if(!element.type) element.type = 'info';
                    if(!_.isNumber(element.timeout)) element.timeout = defaultTimeout;
                    if(element.timeout !== 0) {
                        $timeout(() => {
                            this.clear(element);
                        }, element.timeout);
                    }
                    Array.prototype.push.call(this,element);
                },
                configurable: false,
                writable: false,
                enumerable: false
            });

            return UIMessages;
        };

    }).name;
